var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":"","outlined":"","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.$t(_vm.labelKey))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }